import axios from 'axios'
import { getBpIdParam } from '../../common/helper'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'
import { trackFeatureAction } from '../../common/otel'

interface updateGlobalWhatsNewObj {
  media_id: string
  skip_count?: number
  is_dismissed?: boolean
  last_skipped_date?: string
}

const updateGlobalWhatsNew = async (
  updateGlobalWhatsNewObj: updateGlobalWhatsNewObj[],
) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('whatsnew_global_update', 'attempt')
  try {
    const { data } = await axios.patch(
      `${buildURL('updateGlobalWhatsNew', apiConfig.globalWhatsNew)}${bpIdParam}`,
      updateGlobalWhatsNewObj,
    )
    trackFeatureAction('whatsnew_global_update', 'success')
    return data
  } catch (error) {
    trackFeatureAction('whatsnew_global_update', 'error')
    throw error
  }
}

export default updateGlobalWhatsNew
